import { Box, BoxProps, Heading } from '@chakra-ui/react';

import { Markdown } from '~/components/markdown';

export function OutcomeSummary({ title, text, ...boxProps }: { title: string; text: string } & BoxProps) {
  return (
    <Box as='section' {...boxProps}>
      <Heading as='h2' fontWeight='600' size='marketing-3xl'>
        {title}
      </Heading>

      <Box marginTop={{ base: '8px%', sm: '16px' }}>
        <Markdown markdownText={text} />
      </Box>
    </Box>
  );
}
